var _defs, _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2678525bb3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.050781 95 L 71.839844 95 L 71.839844 229 L 9.050781 229 Z M 9.050781 95 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4aee9684e7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 113.320312 -0.660156 L 375.605469 228.992188 L 272.035156 347.277344 L 9.753906 117.625 Z M 113.320312 -0.660156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c299001d06"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 105.953125 -7.113281 L 375.660156 229.042969 L 138.507812 499.894531 L -131.199219 263.742188 Z M 105.953125 -7.113281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2081384e1c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 66 77.320312 L 102 77.320312 L 102 117.816406 L 66 117.816406 Z M 66 77.320312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7365db4d09"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 113.320312 -0.660156 L 375.605469 228.992188 L 272.035156 347.277344 L 9.753906 117.625 Z M 113.320312 -0.660156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af693aaf09"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 105.953125 -7.113281 L 375.660156 229.042969 L 138.507812 499.894531 L -131.199219 263.742188 Z M 105.953125 -7.113281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba9e3dd962"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 91 93 L 365 93 L 365 296 L 91 296 Z M 91 93 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "82c2126578"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 113.320312 -0.660156 L 375.605469 228.992188 L 272.035156 347.277344 L 9.753906 117.625 Z M 113.320312 -0.660156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "52827b8678"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 105.953125 -7.113281 L 375.660156 229.042969 L 138.507812 499.894531 L -131.199219 263.742188 Z M 105.953125 -7.113281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3e1dfe2259"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 77 82.011719 L 112.339844 82.011719 L 112.339844 126.328125 L 77 126.328125 Z M 77 82.011719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "80052f2f2d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 113.320312 -0.660156 L 375.605469 228.992188 L 272.035156 347.277344 L 9.753906 117.625 Z M 113.320312 -0.660156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "56045fa661"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 105.953125 -7.113281 L 375.660156 229.042969 L 138.507812 499.894531 L -131.199219 263.742188 Z M 105.953125 -7.113281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "61f815ffa4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 245 156.304688 L 342 156.304688 L 342 237.3125 L 245 237.3125 Z M 245 156.304688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1067aa648e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 113.320312 -0.660156 L 375.605469 228.992188 L 272.035156 347.277344 L 9.753906 117.625 Z M 113.320312 -0.660156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "963da5b0ef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 105.953125 -7.113281 L 375.660156 229.042969 L 138.507812 499.894531 L -131.199219 263.742188 Z M 105.953125 -7.113281 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2678525bb3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4aee9684e7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c299001d06)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#889e73",
    d: "M 71.542969 95.015625 C 64.378906 95.917969 52.019531 103.546875 44.433594 108.160156 C 24.695312 120.164062 13.703125 128.367188 -4.558594 143.523438 C -17.042969 153.902344 -30.621094 165.105469 -41.355469 177.367188 C -53.855469 191.640625 -51.105469 207.210938 -37.46875 219.828125 C -30.363281 226.40625 -19.601562 230.425781 -10.019531 228.011719 C -2.25 226.050781 12.753906 215.644531 9.734375 205.980469 C 9.136719 204.105469 7.761719 202.574219 6.261719 201.304688 C 0.808594 196.746094 -6.894531 195.023438 -13.773438 196.84375 C -14.695312 197.082031 -15.675781 197.4375 -16.148438 198.277344 C -17.082031 199.863281 -15.453125 201.804688 -13.722656 202.421875 C -12.003906 203.027344 -10.019531 203.007812 -8.511719 204.054688 C -5.789062 205.949219 -6.375 210.21875 -8.550781 212.257812 C -14.578125 217.921875 -24.476562 211.980469 -28.121094 206.410156 C -32.152344 200.304688 -32.601562 192.089844 -29.5625 185.484375 C -22.726562 170.691406 -13.050781 158.480469 -1 147.574219 C 2.886719 144.074219 6.894531 140.707031 10.964844 137.398438 C 27.851562 123.636719 49.644531 111.363281 68.550781 100.554688 Z M 71.542969 95.015625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2081384e1c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7365db4d09)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af693aaf09)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.182295, 1.035203, -1.035203, 1.182295, 93.301083, -225.251822)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 133.419216 147.735694 L 126.189508 148.934896 C 124.431826 149.221702 123.241897 150.881429 123.530108 152.644489 L 125.749303 166.140778 C 126.036108 167.89846 127.697473 169.090258 129.460765 168.79854 L 136.691646 167.608224 Z M 133.419216 147.735694 ",
    stroke: "#282727",
    strokeWidth: 4,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba9e3dd962)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#82c2126578)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#52827b8678)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#889e73",
    d: "M 178.382812 137.195312 L 108.03125 93.445312 L 91.066406 120.710938 L 161.425781 164.453125 C 165.726562 167.125 168.878906 171.28125 170.417969 176.109375 C 174.199219 188.082031 184.75 212.363281 213.542969 230.261719 L 317.882812 295.140625 L 364.792969 219.683594 L 311.4375 186.496094 L 260.464844 154.796875 C 231.671875 136.898438 205.222656 138.15625 192.816406 140.082031 C 187.796875 140.859375 182.691406 139.859375 178.382812 137.195312 Z M 178.382812 137.195312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3e1dfe2259)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#80052f2f2d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#56045fa661)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.182295, 1.035203, -1.035203, 1.182295, 93.301083, -225.251822)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 140.581146 145.938352 L 144.049239 167.030527 C 144.236464 168.191482 143.449019 169.280738 142.292511 169.480589 L 139.551818 169.927669 C 138.388528 170.123547 137.295996 169.332361 137.100118 168.169071 L 133.628285 147.08017 C 133.44106 145.919216 134.230143 144.831829 135.386651 144.631979 L 138.132954 144.179986 C 139.293909 143.992761 140.390181 144.780672 140.581146 145.938352 Z M 140.581146 145.938352 ",
    stroke: "#282727",
    strokeWidth: 4,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#61f815ffa4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1067aa648e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#963da5b0ef)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.182295, 1.035203, -1.035203, 1.182295, 93.301083, -225.251822)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 296.750476 102.462447 L 300.530661 125.409106 L 248.649016 133.937465 L 244.909338 111.150272 ",
    stroke: "#282727",
    strokeWidth: 4,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 217.101562 216.191406 L 211.3125 212.308594 L 216.535156 197.496094 C 216.707031 196.976562 217.121094 195.917969 217.773438 194.3125 C 218.449219 192.707031 218.917969 191.648438 219.207031 191.128906 C 218.734375 191.695312 217.929688 192.535156 216.785156 193.660156 C 215.640625 194.792969 214.820312 195.59375 214.3125 196.054688 L 202.609375 206.449219 L 196.828125 202.554688 L 206.847656 174.433594 L 211.851562 177.808594 L 206.097656 192.964844 C 205.011719 195.746094 203.992188 198.101562 203.050781 200.054688 C 203.53125 199.457031 204.328125 198.601562 205.433594 197.457031 C 206.550781 196.3125 207.464844 195.449219 208.175781 194.851562 L 220.6875 183.761719 L 225.496094 186.984375 L 219.976562 202.796875 C 219.71875 203.496094 219.285156 204.546875 218.679688 205.929688 C 218.089844 207.316406 217.542969 208.5 217.054688 209.46875 C 217.746094 208.691406 218.640625 207.738281 219.734375 206.625 C 220.832031 205.515625 221.746094 204.632812 222.457031 203.980469 L 234.324219 192.9375 L 239.347656 196.292969 Z M 217.101562 216.191406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 226.21875 222.320312 L 242.355469 198.324219 L 247.453125 201.757812 L 231.316406 225.753906 Z M 226.21875 222.320312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 258.628906 244.121094 L 252.175781 239.792969 L 253.945312 214.597656 L 253.800781 214.507812 C 251.839844 217.855469 250.394531 220.203125 249.484375 221.558594 L 241.886719 232.859375 L 237.34375 229.8125 L 253.484375 205.804688 L 259.90625 210.125 L 258.234375 235.109375 L 258.339844 235.1875 C 260.28125 231.964844 261.6875 229.714844 262.550781 228.417969 L 270.1875 217.046875 L 274.765625 220.125 Z M 258.628906 244.121094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 278.5 257.488281 L 264.667969 248.179688 L 280.804688 224.183594 L 294.636719 233.484375 L 291.835938 237.660156 L 283.105469 231.792969 L 279.554688 237.0625 L 287.671875 242.515625 L 284.855469 246.699219 L 276.738281 241.234375 L 272.59375 247.410156 L 281.324219 253.277344 Z M 278.5 257.488281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWine);
export default __webpack_public_path__ + "static/media/wine.8a9edc8a1bbdf528a09dcead05aec1c8.svg";
export { ForwardRef as ReactComponent };